import { commaJoin } from 'service/utility';

export const CHART_TYPES = ['dailyTraffic', 'dailyHigh', 'dailyAvg', 'hourlyCapacity', 'hourlyIncoming', 'hourlyOutgoing', 'hourlyCount'];
export const CHART_TYPES_STRING = commaJoin(CHART_TYPES);
